// tslint:disable
import axios from 'axios';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Route, Switch } from 'react-router';
import { BrowserRouter } from 'react-router-dom';
import SweetAlert from 'sweetalert';
import { Authorize } from './components/libs/authorize';
import { MetadataReaderLib } from './components/libs/metadata-reader.lib';
import { EntityDetailsComponent } from './components/structurals/entity-details.component';
import { ForgotPasswordComponenet } from './components/structurals/forgot-password.componenet';
import { HeaderComponent } from './components/structurals/header.component';
import { LoginComponent } from './components/structurals/login.component';
import { SidebarComponent } from './components/structurals/sidebar/sidebar.component';
import { WelcomeComponent } from './components/structurals/welcome.component';
import { Environment } from './environment/environment';
import registerServiceWorker from './registerServiceWorker';
import './scss/contentbuilder/asp.scss';
import './scss/contentbuilder/atas.scss';
import './scss/index.scss';

(window as any).API_META_ENV = {
    production: false,
    env: null
};

export class Index extends React.Component<any, any> {
    public state: any = {
        isInitialized: false
    };

    async componentWillMount() {
        try {
            const meta = await axios.get(Environment.get('api.meta'));

            (window as any).API_META_ENV = meta.data;

            await MetadataReaderLib.init();
            this.setState({isInitialized: true});
        } catch (err) {

        }
    }

    componentDidMount() {
        const currentUri = location.pathname.substring(1);

        const exluded = ['login', 'forgot-password'];

        if (exluded.indexOf(currentUri) < 0) {
            Authorize.authorize();
        }
    }

    render() {
        return (
            this.state.isInitialized ? <BrowserRouter>
                <Switch>
                    <Route path="/login" component={LoginComponent}/>
                    <Route path="/forgot-password" component={ForgotPasswordComponenet}/>
                    <Route
                        component={() => <div id="page-wrapper">
                            <HeaderComponent/>
                            <SidebarComponent/>
                            <div id="page-content-wrapper">
                                <div id="page-content">
                                    <div className="container">
                                        <Switch>
                                            <Route exact={true} path="/" component={WelcomeComponent}/>
                                            <Route path="/:entity/:id" component={EntityDetailsComponent}/>
                                            <Route path="/:entity" component={EntityDetailsComponent}/>
                                        </Switch>
                                    </div>
                                </div>
                            </div>
                        </div>}
                    />
                </Switch>
            </BrowserRouter> : <span/>
        );
    }
}

export abstract class Notification {

    public jokes = [];

    public static notify(options: any) {
        return SweetAlert(options);
    }

    public static authFailed() {
        SweetAlert({
            title: 'Please login',
            icon: 'error',
        });
    }

    public static successSave(text?: string) {
        SweetAlert({
            title: 'Save successful',
            text: text ? text.toString() : '',
            icon: 'success',
            timer: 3000
        });
    }

    public static errorExec(text: string) {
        return SweetAlert({
            title: 'Warning',
            text: text.toString(),
            icon: 'warning',
        });
    }

    public static delete(text?: string) {
        return SweetAlert({
            title: 'Are you sure to delete this item?',
            text: text || '',
            icon: 'warning',
            buttons: [
                'Cancel',
                'Yes, delete!'
            ]
        });
    }

    public static success(title: string, message?: string) {
        return SweetAlert({
            title: title.toString() || '',
            text: message ? message.toString() : '',
            icon: 'success'
        });
    }

    public static error(title: string, message: string) {
        return SweetAlert(title, message ? message.toString() : '', 'error');
    }

    public static prompt(title: string, message: string, status: string) {
        return SweetAlert({
            title: title.toString() || '',
            text: message.toString() || '',
            icon: status.toString() || '',
            buttons: [
                'cancel',
                'confirm'
            ]
        });
    }
}

ReactDOM.render(
    <Index/>,
    document.getElementById('sb-site') as HTMLElement
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx